<template>
  <div>
    <h5>Distributed Acoustic Sensing (DAS)</h5>
    <div style="background-color: white">
      <DASChartComponent :data="chartData" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, defineProps } from 'vue'
import { Alarm, AlarmClient, DASChart } from '@/server/MakeSenseApp-backend'
import DASChartComponent from '../DasChart.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'

const props = defineProps({
  alarm: Alarm
})

const chartData = ref<DASChart | undefined>(undefined)
let store = useProjectStore()

onMounted(() => {
  const alarmClient = requiredInject<AlarmClient>('AlarmClient')

  if (props.alarm === undefined || props.alarm.id === undefined) {
    console.error('Alarm ID is undefined')
    return
  }

  alarmClient.dasForAlarm(store.projectId, props.alarm.id).then((data) => {
    chartData.value = data as DASChart
  })
})
</script>

<style scoped></style>
